import React from 'react';
import { inject, observer } from 'mobx-react';
import type { AppStore } from '@stores/app/store';
import type { SiteStore } from '@stores/site/store';
import type { UserAction } from '@stores/user/action';
import type { TopicAction } from '@stores/topic/action';
import type { ThreadAction } from '@stores/thread/action';
import { BasePage } from '@components/Base/BasePage';
import styles from './index.module.scss';
import type { BasePageProps } from '../../../../types/base';
import { withRouter } from 'react-router-dom';
import { RouteComponentProps } from 'react-router-dom';
import { BASE_IMG_URL } from '@images/imageUrls';
import TabNav from '@components/tabNav';
import TabFilter from '@components/tabFilter';
import ThreadList from '@components/threadList';
import { formatNumberToWan } from '@utils/formatNumber'
import classNames from 'classnames';
import DownloadApp from '@components/downloadApp';
import SidebarTopicList from '@components/sidebarTopicList';
import SidebarUserInfo from '@components/sidebarUserInfo';
interface RouteParams {
    id: string;
}
interface TopicDetailPCPageProps extends BasePageProps, RouteComponentProps<RouteParams> {
    app?: AppStore;
    site?: SiteStore;
    user?: UserAction;
    topic?: TopicAction;
    thread?: ThreadAction;
    filterList?: any
    navList?: any
    navClick?: Function
    filterClick?: Function
    navCurrentIndex?: any
    filterCurrentIndex?: any
    handleSetState: any
    createTopicsFollow?: any
    createTopicsUnFollow?: any
    handleFollowToggle?: any
    handleLoadMore?: any
    idsArray?: any
    showType: any
    stickyThreadList?: any[]
    stickyListLoading?: boolean
    topicThreadLoading?: boolean
}
interface TopicDetailPCState {
    loading: boolean;
    error: any
    pageLoaded: any
    // topicDetail: any
    // navList: any
    // filterList: any
    // navCurrentIndex: any
    // filterCurrentIndex: any
    topicList: any
    windowWidth: any
    scrollY: any
    stickyExpanded: boolean
    stickyLikeOverrides: Record<string, { isLiked: boolean; likeCount: number }>
    crossTopicDropdownOpen: boolean
}
@inject('app', 'site', 'user', 'topic', 'thread')
@observer
class TopicDetailPCPage extends BasePage<TopicDetailPCPageProps, TopicDetailPCState> {
    state = {
        loading: false,
        error: null,
        pageLoaded: false,
        // topicDetail: {},    // 话题详情数据
        // navList: [
        //     {name: '综合', id: 0, type: '0'},
        //     {name: '图文', id: 0, postCount: '1'},
        //     {name: '视频', id: 1, postCount: '2'},
        // ],
        // navCurrentIndex: 0, // 导航当前选中索引
        // filterList: [
        //     {name: '默认', id: 0, type: '0'},
        //     {name: '热门', id: 0, postCount: '1'},
        //     {name: '最新', id: 1, postCount: '2'},
        // ],
        // filterCurrentIndex: 0,  // 筛选当前选中索引
        topicList: [],
        windowWidth: 0, // 浏览器宽度
        scrollY: 0, // 滚动高度
        stickyExpanded: false,
        stickyLikeOverrides: {},
        crossTopicDropdownOpen: false,
    };
    // 防抖定时器
    private resizeTimeout: NodeJS.Timeout | null = null;
    private scrollTimeout: NodeJS.Timeout | null = null;
    async componentDidMount() {
        // 初始化窗口尺寸和滚动位置
        this.updateWindowDimensions();
        this.updateScrollPosition();
        // 添加事件监听
        window.addEventListener('resize', this.handleResize);
        window.addEventListener('scroll', this.handleScroll);
        super.componentDidMount();
    }
    componentWillUnmount() {
        // 移除事件监听
        window.removeEventListener('resize', this.handleResize);
        window.removeEventListener('scroll', this.handleScroll);

        // 清除定时器
        if (this.resizeTimeout) {
            clearTimeout(this.resizeTimeout);
        }
        if (this.scrollTimeout) {
            clearTimeout(this.scrollTimeout);
        }
    }


    // 更新窗口尺寸
    updateWindowDimensions = () => {
        this.setState({
            windowWidth: window.innerWidth
        });
    }

    // 更新滚动位置
    updateScrollPosition = () => {
        const scrollY = window.scrollY || document.documentElement.scrollTop;
        this.setState({ scrollY });

        // 检查滚动高度是否超过200px
        if (scrollY > 270) {
            // console.log(`🎯 滚动高度超过200px，当前滚动高度: ${scrollY}px`);
            // console.log(`📱 当前浏览器宽度: ${window.innerWidth}px`);
        }
    }

    // 防抖处理窗口大小变化
    handleResize = () => {
        if (this.resizeTimeout) {
            clearTimeout(this.resizeTimeout);
        }
        this.resizeTimeout = setTimeout(() => {
            this.updateWindowDimensions();
            console.log(`🔄 浏览器宽度变化: ${window.innerWidth}px`);
        }, 100);
    }

    // 防抖处理滚动事件
    handleScroll = () => {
        if (this.scrollTimeout) {
            clearTimeout(this.scrollTimeout);
        }
        this.scrollTimeout = setTimeout(() => {
            this.updateScrollPosition();
        }, 16); // 约60fps
    }

    // 处理导航点击
    handleNavClick = (item: any, index: number) => {
        console.log('导航点击:', { item, index });
        this.setState({ crossTopicDropdownOpen: false });
        
        // 调用父组件传递的函数
        const { navClick } = this.props;
        if (navClick) {
            navClick(item, index);
        }
    }

    // 处理筛选点击
    handleFilterClick = (item: any, index: number) => {
        console.log('导航点击:', { item, index });
        
        // 调用父组件传递的函数
        const { filterClick } = this.props;
        if (filterClick) {
            filterClick(item, index);
        }
    }

    getBaseNavList = () => {
        const { navList = [] } = this.props;
        return (navList || []).filter((item: any) => item?.id === 0);
    }

    getAssociatedTopicList = () => {
        const { navList = [] } = this.props;
        return (navList || []).filter((item: any) => item?.id !== 0);
    }

    getCurrentAssociatedTopic = () => {
        const associatedTopics = this.getAssociatedTopicList();
        const { navCurrentIndex = 0, navList = [] } = this.props;
        const currentItem = navList?.[navCurrentIndex];
        if (currentItem?.id !== 0) {
            return currentItem;
        }
        return associatedTopics[0] || null;
    }

    renderCrossTopicNav = () => {
        const { navCurrentIndex = 0, navList = [] } = this.props;
        const { crossTopicDropdownOpen } = this.state;
        const baseTabs = this.getBaseNavList();
        const associatedTopics = this.getAssociatedTopicList();

        if (associatedTopics.length <= 3) {
            return (
                <TabNav
                    navList={navList}
                    isAlignLeft={true}
                    showAlias={true}
                    currentIndex={navCurrentIndex}
                    navClick={(item: any, index: any) => this.handleNavClick(item, index)}
                />
            );
        }

        const currentAssociatedTopic = this.getCurrentAssociatedTopic();
        const currentItem = navList?.[navCurrentIndex];
        const isAssociatedActive = currentItem?.id !== 0;
        const dropdownLabel = currentAssociatedTopic?.associatedAlias || currentAssociatedTopic?.name || '交叉话题';

        return (
            <div className={styles.crossTopicNav}>
                {baseTabs[0] ? (
                    <div
                        className={classNames(styles.crossTopicNavItem, navCurrentIndex === 0 ? styles.crossTopicNavItemActive : '')}
                        onClick={() => this.handleNavClick(baseTabs[0], 0)}
                    >
                        <span>{baseTabs[0].name}</span>
                    </div>
                ) : null}

                <div className={styles.crossTopicDropdownWrap}>
                    <div
                        className={classNames(styles.crossTopicNavItem, isAssociatedActive ? styles.crossTopicNavItemActive : '')}
                        onClick={() => this.setState({ crossTopicDropdownOpen: !crossTopicDropdownOpen })}
                    >
                        <span className={styles.crossTopicDropdownLabel}>{dropdownLabel}</span>
                        <img
                            src="https://vivo-oss-sz-7026.oss-cn-shenzhen.aliyuncs.com/iqoo-mini/wuhu/arrowDwon.png"
                            alt=""
                            className={classNames(styles.crossTopicDropdownArrow, crossTopicDropdownOpen ? styles.crossTopicDropdownArrowOpen : '')}
                        />
                    </div>

                    {crossTopicDropdownOpen ? (
                        <div className={styles.crossTopicDropdownMenu}>
                            {associatedTopics.map((item: any) => {
                                const realIndex = navList.findIndex((navItem: any) => String(navItem?.id) === String(item?.id));
                                const isActive = String(currentItem?.id) === String(item?.id);
                                return (
                                    <div
                                        key={item.id}
                                        className={classNames(styles.crossTopicDropdownOption, isActive ? styles.crossTopicDropdownOptionActive : '')}
                                        onClick={() => this.handleNavClick(item, realIndex)}
                                    >
                                        {item.associatedAlias || item.name}
                                    </div>
                                );
                            })}
                        </div>
                    ) : null}
                </div>

                {baseTabs.slice(1).map((item: any) => {
                    const realIndex = navList.findIndex((navItem: any) => navItem?.id === item?.id && navItem?.type === item?.type && navItem?.name === item?.name);
                    const isActive = navCurrentIndex === realIndex;
                    return (
                        <div
                            key={`${item.name}-${item.type}`}
                            className={classNames(styles.crossTopicNavItem, isActive ? styles.crossTopicNavItemActive : '')}
                            onClick={() => this.handleNavClick(item, realIndex)}
                        >
                            <span>{item.name}</span>
                        </div>
                    );
                })}
            </div>
        );
    }

    renderThreadListSkeleton = () => (
        <div className={styles.threadSkeleton} aria-label="帖子加载中">
            {[0, 1, 2].map((item) => (
                <div className={styles.skeletonCard} key={item}>
                    <div className={`${styles.skeletonShimmer} ${styles.skeletonAvatar}`}></div>
                    <div className={styles.skeletonContent}>
                        <div className={`${styles.skeletonShimmer} ${styles.skeletonUser}`}></div>
                        <div className={`${styles.skeletonShimmer} ${styles.skeletonTitle}`}></div>
                        <div className={`${styles.skeletonShimmer} ${styles.skeletonLine}`}></div>
                        <div className={`${styles.skeletonShimmer} ${styles.skeletonLineShort}`}></div>
                        <div className={`${styles.skeletonShimmer} ${styles.skeletonMeta}`}></div>
                    </div>
                </div>
            ))}
        </div>
    );

    // 帖子列表
    renderThreadList = () => {
        const { topic, handleLoadMore, topicThreadLoading } = this.props;
        if (!topic || !topic.listStore) return null;
        if (topicThreadLoading) return this.renderThreadListSkeleton();
        const list = topic.listStore.lists['topicThreadList'];
        if (!list) return null;
        const flatList = topic.listStore.getList({ namespace: 'topicThreadList' });
        // console.log(flatList, '话题帖子列表');
        return (
            <div style={{ marginBottom: 16 }}>
                <ThreadList
                    data={flatList}
                    loading={list.loading}
                    hasMore={list.hasMore}
                    onLoadMore={handleLoadMore}
                    namespace="topicThreadList"
                    listStore={topic.listStore}
                ></ThreadList>
                {list.loading && <div className={styles.loading}>加载中...</div>}
                {!list.hasMore && !list.loading && <div className={styles.loading}>没有更多了</div>}
                {list.requestError.isError && <div className={styles.loading}>{list.requestError.errorText}</div>}
            </div>
        )
    }

    getStickyThreadPreview = (item: any) => {
        const imageList = Array.isArray(item?.images) ? item.images : [];
        return {
            hasMedia: imageList.length > 0 || !!item?.cover || !!item?.video,
            isVideo: !!item?.video,
            mediaUrl: item?.cover?.thumbUrl
                || item?.cover?.url
                || item?.video?.videoCoverUrl
                || imageList?.[0]?.thumbUrl
                || imageList?.[0]?.url
                || '',
        };
    }

    goThreadDetail = (item: any) => {
        if (item?.id) {
            this.props.history.push(`/threadDetail/${item.id}`);
        }
    }

    goUserDetail = (user: any, e?: React.MouseEvent) => {
        e?.stopPropagation();
        if (user?.code) {
            this.props.history.push(`/user/${user.code}`);
        }
    }

    // 置顶帖标签渲染（爆热顶精荐）
    stickyTagRender = (item: any) => {
        const tags: any = [];
        if (item.isBoom) {
            tags.push({ img: `${BASE_IMG_URL}/common/fire.png`, alt: '爆款' });
        } else if (item.isHot) {
            tags.push({ img: `${BASE_IMG_URL}/common/hot.png`, alt: '热门' });
        } else if (item.isSticky || item.showIndex) {
            tags.push({ img: `${BASE_IMG_URL}/common/stick.png`, alt: '置顶' });
        } else if (item.isEssence) {
            tags.push({ img: `${BASE_IMG_URL}/common/essence.png`, alt: '精华' });
        } else if (item.isRecommend) {
            tags.push({ img: `${BASE_IMG_URL}/common/recommend.png`, alt: '推荐' });
        }
        if (tags.length === 0) return null;
        return (
            <>
                {tags.map((tag, index) => (
                    <img
                        key={index}
                        src={tag.img}
                        alt={tag.alt}
                        className={styles.stickyTagIcon}
                        title={tag.alt}
                    />
                ))}
            </>
        );
    };

    // 获取图片数量
    getImageCount = (item: any) => {
        const imageList = Array.isArray(item?.images) ? item.images : [];
        return imageList.length;
    }

    handleStickyLike = async (item: any, e: React.MouseEvent) => {
        e.stopPropagation();
        const { thread, topic } = this.props;
        if (!thread) return;

        window.globalEnsureLogin(async () => {
            const itemId = String(item.id || item._id);
            const current = this.state.stickyLikeOverrides[itemId] || {
                isLiked: !!item.isLiked,
                likeCount: item.likeCount || 0,
            };
            const nextIsLiked = !current.isLiked;
            const nextLikeCount = nextIsLiked
                ? current.likeCount + 1
                : Math.max(current.likeCount - 1, 0);

            this.setState(prevState => ({
                stickyLikeOverrides: {
                    ...prevState.stickyLikeOverrides,
                    [itemId]: {
                        isLiked: nextIsLiked,
                        likeCount: nextLikeCount,
                    },
                },
            }));

            try {
                const ret = await thread.createUserslikes({
                    id: item.id,
                    type: 'thread',
                    isLiked: nextIsLiked,
                    likeCount: current.likeCount,
                });
                // 同步更新 topic 列表里同一条 thread 的点赞状态
                const serverLikeCount = ret?.data?.likeCount;
                topic?.updateThreadInTopicList?.({
                    id: item.id,
                    isLiked: nextIsLiked,
                    likeCount: typeof serverLikeCount === 'number' ? serverLikeCount : nextLikeCount,
                });
            } catch (error) {
                this.setState(prevState => ({
                    stickyLikeOverrides: {
                        ...prevState.stickyLikeOverrides,
                        [itemId]: current,
                    },
                }));
            }
        });
    }

    renderStickyThreadList = () => {
        const { stickyThreadList = [], stickyListLoading, navCurrentIndex, navList = [] } = this.props;

        // 关联话题插入后图文/视频下标会变化，按 tab 类型判断。
        const currentNav = navList[navCurrentIndex];
        if (currentNav?.type === '1' || currentNav?.type === '2') {
            return null;
        }
        const { stickyExpanded, stickyLikeOverrides } = this.state;

        if (stickyListLoading && stickyThreadList.length === 0) {
            return <div className={styles.stickyLoading}>加载置顶帖中...</div>;
        }

        if (!stickyThreadList.length) {
            return null;
        }

        const displayList = stickyExpanded ? stickyThreadList : stickyThreadList.slice(0, 3);

        return (
            <div className={styles.stickySection}>
                {displayList.map((item: any) => {
                    const itemId = String(item.id || item._id);
                    const override = stickyLikeOverrides[itemId];
                    const mergedItem = override ? { ...item, ...override } : item;
                    const { hasMedia, isVideo, mediaUrl } = this.getStickyThreadPreview(item);
                    const stickyCommentText = Number(mergedItem.postCount || 0) > 0 ? formatNumberToWan(mergedItem.postCount || 0) : '首评';
                    const stickyLikeText = Number(mergedItem.likeCount || 0) > 0 ? formatNumberToWan(mergedItem.likeCount || 0) : '首赞';
                    const hasTitle = Number(item.type) === 0
                        && typeof item.title === 'string'
                        && item.title.trim().length > 0;
                    const primaryText = hasTitle ? item.title : (item.summary || item.title || '置顶帖');
                    return (
                        <div
                            key={item.id || item._id}
                            className={styles.stickyCard}
                            onClick={() => this.goThreadDetail(item)}
                        >
                            {hasMedia ? (
                                <div className={styles.stickyMediaBox}>
                                    {mediaUrl ? <img src={mediaUrl} alt="" className={styles.stickyMediaImage} /> : null}
                                    {isVideo ? <img src={`${BASE_IMG_URL}/common/play.png`} alt="" className={styles.stickyPlayIcon} /> : null}
                                    {!isVideo && this.getImageCount(item) > 1 ? (
                                        <div className={styles.stickyImageCount}>{this.getImageCount(item)}</div>
                                    ) : null}
                                </div>
                            ) : null}
                            <div className={styles.stickyMain}>
                                <div className={styles.stickyTitleRow}>
                                    {this.stickyTagRender(item)}
                                    <span className={classNames(styles.stickyTitle, !hasTitle && styles.stickyTitleRegular)}>
                                        {primaryText}
                                    </span>
                                </div>
                                {hasTitle && item.summary ? <div className={styles.stickySummary}>{item.summary}</div> : null}
                                <div className={styles.stickyMetaRow}>
                                    <div className={styles.stickyAuthor} onClick={(e) => this.goUserDetail(item.user, e)}>
                                        <img className={styles.stickyAvatar} src={item.user?.avatar || `${BASE_IMG_URL}/common/official2.png`} alt="" />
                                        <span className={styles.stickyAuthorName}>{item.user?.nickname || '普通用户'}</span>
                                    </div>
                                    <div className={styles.stickyStats}>
                                        <span className={styles.stickyStat}>
                                            <img src={`${BASE_IMG_URL}/common/comment.png`} alt="评论" className={styles.stickyStatIcon} />
                                            <span>{stickyCommentText}</span>
                                        </span>
                                        <span className={styles.stickyStat} onClick={(e) => this.handleStickyLike(item, e)}>
                                            <img src={`${BASE_IMG_URL}/common/${mergedItem.isLiked ? 'liked' : 'like'}.png`} alt="点赞" className={styles.stickyStatIcon} />
                                            <span className={mergedItem.isLiked ? styles.stickyLikedCount : ''}>{stickyLikeText}</span>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    );
                })}
                {stickyThreadList.length > 3 ? (
                    <div
                        className={styles.stickyToggle}
                        onClick={() => this.setState({ stickyExpanded: !stickyExpanded })}
                    >
                        <span>{stickyExpanded ? '收起置顶帖' : `查看全部${stickyThreadList.length}条置顶帖`}</span>
                        <img
                            src="https://vivo-oss-sz-7026.oss-cn-shenzhen.aliyuncs.com/iqoo-mini/wuhu/arrowDwon.png"
                            alt=""
                            className={classNames(styles.stickyToggleArrow, stickyExpanded ? styles.stickyToggleArrowUp : '')}
                        />
                    </div>
                ) : null}
            </div>
        );
    }

    // 话题标签
    tagRender = (item) => {
        const tags: any = [];

        // 第一优先级标签, 规则 最多显示2个标签，第一个标签优先级：爆>热>顶>精>无； 
        if (item?.isHot) {
            tags.push({ img: `${BASE_IMG_URL}/common/topic_hot.png`, alt: '热' });
        } else if (item?.isNew) {
            tags.push({ img: `${BASE_IMG_URL}/common/topic_new.png`, alt: '新' });
        } else if (item?.isRecommended) {
            tags.push({ img: `${BASE_IMG_URL}/common/topic_recommend.png`, alt: '推荐' });
        }
        if (tags.length === 0) {
            return null;
        }

        return (
            <div>
                {tags.map((tag, index) => (
                    <img
                        key={index}
                        src={tag.img}
                        alt={tag.alt}
                        className={styles.topicTag}
                        title={tag.alt}
                    />
                ))}
            </div>
        );
    };


    // 首页左侧侧内容
    readerLeft = () => {
        let { filterList, navList, navCurrentIndex, filterCurrentIndex, handleFollowToggle, showType, createTopicsUnFollow, navClick, filterClick } = this.props;
        let { scrollY, windowWidth } = this.state;
        let { topicDetail } = this.props.topic;
        let isHaveTopicTag = topicDetail?.isHot || topicDetail?.isRecommended || topicDetail?.isNew;  // 话题是否有标签
        // console.log(showType, '详情---参数----');
        // 使用vw单位，不受滚动条影响
        // 1200px居中，然后减去滚动条宽度（假设平均17px）
        const leftValue = `calc(50vw - 600px - 0.5 * (100vw - 100%))`;
        return (
            <div className={styles.leftContent}>
                {scrollY > 270 && <div className={styles.fixedNavFilterBox} style={{ left: leftValue }}>
                    {this.renderCrossTopicNav()}
                    <TabFilter filterList={filterList} listStylesData={{background: '#E8E9EB'}} currentIndex={filterCurrentIndex} filterClick={(item: any, index: any) => this.handleFilterClick(item, index)}></TabFilter>
                </div>}
                {(showType != 0) &&  <div className={styles.topicDetailBox} style={{ background: topicDetail?.background }}>
                    {/* <img src={topicDetail?.cover || `${BASE_IMG_URL}/common/topic_bg1.png`} alt="" className={styles.topicCover}/> */}
                    {topicDetail?.avatar && <img src={topicDetail?.avatar} alt="" className={styles.topicCover} />}
                    <div className={styles.topicDetail}>
                        <div className={classNames(styles.topicNameBox, isHaveTopicTag ? styles.topicHaveTag : '')}>
                            {/* <img src={`${BASE_IMG_URL}/common/topic_prize.png`} alt="" className={styles.topicTag}/> */}
                             {this.tagRender(topicDetail)}
                            <div className={styles.topicName}>
                                <span>{topicDetail?.name}</span>
                            </div>
                        </div>

                        <div className={styles.topicCount}>
                            <span>{formatNumberToWan(topicDetail?.threadCount)}帖子</span>
                            <span>{formatNumberToWan(topicDetail?.discussionCount)}讨论量</span>
                        </div>
                        <div className={styles.topicInfo}>
                            {/* <div className={styles.moderator}>版主</div> */}
                            <span className={styles.followCount}>{formatNumberToWan(topicDetail?.followCount)}人关注</span>
                            {!topicDetail?.isFollowed && <div className={styles.followBtn} onClick={() => {
                                window.globalEnsureLogin(() => {
                                    handleFollowToggle && handleFollowToggle()
                                });
                            }}>关注</div>}
                            {topicDetail?.isFollowed && <div className={styles.followedBtn} onClick={() => {
                                window.globalEnsureLogin(() => {
                                    handleFollowToggle && handleFollowToggle()
                                });
                            }}>已关注</div>}
                        </div>
                    </div>
                </div>}
                <div className={styles.navFilterBox}>
                    {this.renderCrossTopicNav()}
                    <TabFilter filterList={filterList} listStylesData={{background: '#E8E9EB'}} currentIndex={filterCurrentIndex} filterClick={(item: any, index: any) => this.handleFilterClick(item, index)}></TabFilter>
                </div>
                {this.renderStickyThreadList()}
                {this.renderThreadList()}
            </div>
        );
    }

    // 首页右侧内容
    readerRight = () => {
        let { topicList } = this.state;
        let { idsArray } = this.props;
        let isLogin = false;
        return (
            <div className={styles.rightContent}>
                {/* 用户信息 */}
                <SidebarUserInfo topicId={idsArray}></SidebarUserInfo>
                {/* 下载app */}
                <DownloadApp></DownloadApp>
                {/* 热门话题 */}
                <SidebarTopicList></SidebarTopicList>

            </div>
        );
    }


    render() {
        let isHaveTopicTag = true;  // 话题是否有标签
        return (<div className={styles.wrapper}>

            {this.readerLeft()}
            {this.readerRight()}

        </div>)
    }
}

export default withRouter(TopicDetailPCPage);
